export const pageNameToType = {
  myway: {
    'myway/account': 'account',
    'myway/account/my-purchases': 'account',
    'myway/account/car-agent': 'account',
    'myway/account/favorites': 'account',
    'myway/account/login': 'form',
    'myway/account/manage': 'account',
    'myway/account/overview': 'account',
    'myway/account/password': 'form',
    'myway/account/new-password': 'form',
    'myway/account/password-change': 'form',
    'myway/account/password-recovery': 'form',
    'myway/account/recovery': 'form',
    'myway/account/password-reset': 'form',
    'myway/account/register': 'form',
    'myway/car-details': 'product',
    'myway/comparison': 'form',
    'myway/contact': 'support',
    'myway/contact/contact-dealer': 'form',
    'myway/contact/customer-service': 'form',
    'myway/contact/find-dealer': 'form',
    'myway/error': 'error',
    'myway/faq': 'support',
    'myway/home': 'homepage',
    'myway/legal': 'information',
    'myway/mywaydirect': 'information',
    'myway/myway-direct': 'information',
    'myway/privacy': 'information',
    'myway/checkout/personal-info': 'form',
    'myway/checkout/type': 'form',
    'myway/checkout/financing/simulation': 'form',
    'myway/checkout/financing/login': 'form',
    'myway/checkout/financing/personal-info': 'form',
    'myway/checkout/financing/profession': 'form',
    'myway/checkout/financing/address': 'form',
    'myway/checkout/financing/personal-data': 'form',
    'myway/checkout/financing/legal-questions': 'form',
    'myway/checkout/financing/overview': 'form',
    'myway/checkout/financing/documents': 'form',
    'myway/checkout/handover': 'form',
    'myway/checkout/review': 'form',
    'myway/checkout/payment': 'form',
    'myway/checkout/thank-you': 'form',
    'myway/checkout': 'form',
    'myway/reservation': 'form',
    'myway/search-agent': 'search',
    'myway/search-results': 'search',
    'myway/services-autocredit': 'information',
    'myway/services-classic-financing': 'information',
    'myway/services-financial-leasing': 'information',
    'myway/services-guarantee': 'information',
    'myway/services-long-term-renting': 'information',
    'myway/sitemap': 'information',
    'myway/services-renting': 'information'
  },
  default: {
    'dealersite/used-cars': 'search',
    'dealersite/privacy': 'information',
    'dealersite/stock': 'search',
    'dealersite/used-cars/car-details': 'product',
    'dealersite/error': 'errorType',
    'dealersite/favorites': 'product',
    'dealersite/comparison': 'product',
    'dealersite/used-cars/search': 'search'
  }
};

export const buttonCategoryMap = {
  'internal-link': 'inbound-link',
  'external-link': 'outbound-link'
};

export const vehicleToCommerce = (vehicle) => {
  const { body, make, model, version, hp, gearboxKey, exteriorColor, interiorColor, equipments, firstRegistrationYear, mileage, price, identification, fuelKey, reference } = vehicle;

  let optionsList;
  if (equipments && equipments.length > 1) {
    optionsList = equipments.map((equipment) => equipment.key);
  } else {
    optionsList = '';
  }

  return {
    carBodyType: body || '',
    carBrand: make || '',
    carModel: model || '',
    carEquipmentLine: version || '',
    carEngineType: fuelKey || '',
    carEnginePower: hp?.toString() || '',
    carGearboxType: gearboxKey || '',
    carExteriorColor: exteriorColor || '',
    carInteriorColor: interiorColor || '',
    carConfigCode: '',
    carOptionsList: optionsList || '',
    referenceID: identification || '',
    expertReference: reference || '',
    carMileage: mileage?.toString() || '',
    carYear: firstRegistrationYear?.toString() || '',
    carTotalPrice: price?.toString() || '',
    carPrice: ''
  };
};

export const vehicleToCommerceClick = (vehicle) => {
  if (!vehicle) return {};
  const { body, make, model, version, hp, gearboxKey, exteriorColor, interiorColor, equipmentKeys, firstRegistrationYear, mileage, price, identification, fuelKey, reference } = vehicle;

  return {
    carBodyType: body || '',
    carBrand: make || '',
    carModel: model || '',
    carEquipmentLine: version || '',
    carEngineType: fuelKey || '',
    carEnginePower: hp?.toString() || '',
    carGearboxType: gearboxKey || '',
    carExteriorColor: exteriorColor || '',
    carInteriorColor: interiorColor || '',
    carConfigCode: '',
    carOptionsList: equipmentKeys || '',
    referenceID: identification || '',
    expertReference: reference || '',
    carMileage: mileage?.toString() || '',
    carYear: firstRegistrationYear?.toString() || '',
    carTotalPrice: price?.toString() || '',
    carPrice: ''
  };
};

export const companyCodeToParams = {
  default: {
    platform: 'dealersite',
    brand: 'multibrand',
    pageviewMode: 'dealer'
  },
  myway: {
    platform: 'main',
    brand: 'myway',
    pageviewMode: 'national|private'
  },
  aaplus: {
    platform: 'aap',
    brand: 'myway',
    pageviewMode: 'national'
  },
  mywayb2b: {
    platform: 'main',
    brand: 'myway',
    pageviewMode: 'national|professional_b2b'
  }
};
